import React, { useEffect, useRef, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa';
import { useSelector } from 'react-redux';


import Select from "react-select";

const JoinAsField = ({
    onChange,
    labelName,
    defaultValue,
    disabled,
    errorOccured,
    errorMessage,
}) => {
    const { role, rolesUserCanAssign } = useSelector((state) => state.user);

    const admin = [
        { value: "1", label: "Professional" },
    ]

    const superadmin = [
        { value: "2", label: "Customer" },
        { value: "1", label: "Professional" },
        { value: "4", label: "Admin" },
    ]

    const [activated, setActivated] = useState(true);
    const labelRef = useRef();
    const [coverWidth, setCoverWidth] = useState(0);

    useEffect(() => {
        setCoverWidth(
            labelRef.current ? labelRef.current.getBoundingClientRect().width + 9 : 0
        );
        // if (options?.length > 0) {
        //     setActivated(true);
        // }
    }, [labelRef]);

    return (
        //     <div className="mb-3">

        //         <label className="mb-1"><strong>{"Register as"} </strong></label>
        //         <div>
        //             <select placeholder='Select' style={{ border: '2px solid rgba(107, 107, 107, 0.12)', cursor: 'pointer' }} className="custom-select join-as-style" required onChange={onChange} value={defaultValue}>
        //                 {role === 3 ? (
        //         superadmin.map((option) => (
        //             <option value={option.value}>{option.label}</option>
        //         ))) : (admin.map((option) => (
        //             <option value={option.value} disabled={option.value == 2}>{option.label}</option>
        //         )))
        //     }
        //                 {rolesUserCanAssign.map((option) => (
        //                     <option value={option.role_id_ids}>{option.role_display_name_chr}</option>
        //                 ))}
        //             </select>
        //         </div>
        //     </div>
        <>
            <div className="col-12 mb-4">
                <InputGroup
                    className={`${errorOccured ? "" : "mb-2"} position-relative`}
                    onFocus={() => {
                        setActivated(true);
                    }}
                >
                    {" "}
                    <>
                        <Form.Group controlId="exampleForm.SelectCustom" className="col-12 border-danger">
                            {/* <Form.Label>Select Options</Form.Label> */}
                            <Form.Label
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-activated"
                                    : "textfield-label-unactivated"
                                    } textfield-label`}
                                ref={labelRef}
                                onClick={() => {
                                    setActivated(true);
                                }}>
                                <strong className={`${errorOccured && 'text-danger'}`}> {labelName}</strong>
                            </Form.Label>
                            <div
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-cover-activated"
                                    : "textfield-label-cover-unactivated"
                                    } textfield-label-cover `}
                                style={{ width: coverWidth }}></div>
                            <Form.Control
                                className={`${errorOccured && 'border-danger'}`}
                                as="select"
                                custom
                                required
                                onChange={onChange}
                                defaultValue={defaultValue}
                                disabled={disabled}
                                value={defaultValue}
                            >
                                {/* <option value={''} disabled>Select role</option> */}

                                {rolesUserCanAssign.map((option) => (
                                    <option value={option.role_id_ids}>{option.role_display_name_chr}</option>
                                ))}

                            </Form.Control>

                            <div
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-cover-activated"
                                    : "textfield-label-cover-unactivated"
                                    } textfield-label-cover`}
                                style={{ width: "20px" }}></div>
                        </Form.Group>

                        <FaChevronDown style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            pointerEvents: 'none',
                            color: errorOccured ? 'red' : 'gray'
                        }} />
                    </>
                    {errorOccured && (
                        <span style={{ color: "red", fontSize: "10px" }}>
                            {errorMessage}
                        </span>
                    )}
                </InputGroup>
            </div>
        </>

    )
}

export default JoinAsField